import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useAdminScreenStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '60vh',
    textAlign: 'center',
    padding: tokens.spacingVerticalXXL,
  },
  icon: {
    fontSize: fontScale.heading,
    marginBottom: tokens.spacingVerticalL,
    color: tokens.colorBrandForeground1,
  },
  title: {
    fontSize: fontScale.title,
    fontWeight: tokens.fontWeightSemibold,
    marginBottom: tokens.spacingVerticalM,
    color: tokens.colorNeutralForeground1,
  },
  description: {
    fontSize: fontScale.body,
    color: tokens.colorNeutralForeground2,
    maxWidth: '25rem',
  },
});
